// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-chat-conversation-image {
  display: inline-block;
}
.fi-chat-conversation-image .conversation-image-container {
  position: relative;
  width: 34px;
  height: 34px;
}
.fi-chat-conversation-image .conversation-image-container.wide {
  height: 26px;
}
.fi-chat-conversation-image .conversation-image-container .fi-profile-icon {
  left: 0;
  position: absolute;
  top: 0;
}
.fi-chat-conversation-image .conversation-image-container .fi-profile-icon:first-child:not(:only-child) {
  left: 10px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-chat/fi-chat-conversation-image/fi-chat-conversation-image.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;AACJ;AAAI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AAER;AAAQ;EACI,YAAA;AAEZ;AAaQ;EACI,OAAA;EACA,kBAAA;EACA,MAAA;AAXZ;AAcQ;EACI,UAAA;AAZZ","sourcesContent":[".fi-chat-conversation-image {\r\n    display: inline-block;\r\n    .conversation-image-container {\r\n        position: relative;\r\n        width: 34px;\r\n        height: 34px;\r\n\r\n        &.wide {\r\n            height: 26px;\r\n        }\r\n\r\n        // note: commented because Mattias told that we don't need red badge FOR NOW https://chainformation.atlassian.net/browse/FI-4329\r\n        //&.unread-conversation::after {\r\n        //  content: '';\r\n        //  width: 10px;\r\n        //  height: 10px;\r\n        //  border-radius: 50%;\r\n        //  background-color: red;\r\n        //  top: 0;\r\n        //  right: -3px;\r\n        //  position: absolute;\r\n        //}\r\n\r\n        .fi-profile-icon {\r\n            left: 0;\r\n            position: absolute;\r\n            top: 0;\r\n        }\r\n\r\n        .fi-profile-icon:first-child:not(:only-child) {\r\n            left: 10px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
